import { ErrorBase } from './ErrorBase'

export class AuthError extends ErrorBase {
  constructor({ message, cause, code }: { message: string; cause: Error; code?: string }) {
    super({ message, cause, code })
    this.name = 'AuthError'
  }
}
